/**
 * Recently viewed products — localStorage tracker + section renderer.
 * Storage key: mulpotenowa:recently-viewed
 */
(function () {
  if (window.__mulpotenowaRecentlyViewedInit) return;
  window.__mulpotenowaRecentlyViewedInit = true;

  const STORAGE_KEY = 'mulpotenowa:recently-viewed';
  const MAX_ITEMS = 12;

  function readList() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      // Quota / private mode — ignore
    }
  }

  function trackCurrentProduct() {
    const node = document.querySelector('[data-recently-viewed-product]');
    if (!node) return;

    let product;
    try {
      product = JSON.parse(node.textContent);
    } catch (e) {
      return;
    }

    if (!product || !product.handle) return;

    const list = readList().filter((item) => item && item.handle !== product.handle);
    list.unshift({
      id: product.id,
      handle: product.handle,
      url: product.url,
      title: product.title,
      image: product.image || null,
      price: product.price || '',
      price_varies: Boolean(product.price_varies),
      price_note: product.price_note || '税込',
      viewed_at: Date.now(),
    });

    writeList(list.slice(0, MAX_ITEMS));
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildCard(product, priceNote) {
    const note = priceNote || product.price_note || '税込';
    const priceLabel = product.price
      ? `${escapeHtml(product.price)}${product.price_varies ? '〜' : ''}<small>${escapeHtml(note)}</small>`
      : '';

    const imageHtml = product.image
      ? `<img class="index-second__media index-second__media--primary" src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy" width="900" height="828">`
      : '<div class="index-second__tee-placeholder" aria-hidden="true">MEDIA</div>';

    return `
      <a class="index-second__swatch" href="${escapeHtml(product.url)}">
        <span class="index-second__pin" aria-hidden="true"></span>
        <div class="index-second__tee">${imageHtml}</div>
        <div class="index-second__swatch-title">${escapeHtml(product.title)}</div>
        ${
          priceLabel
            ? `<div class="index-second__comment"><p class="index-second__comment-price">${priceLabel}</p></div>`
            : ''
        }
        <div class="index-second__foot"><div class="index-second__dots" aria-hidden="true"></div></div>
      </a>
    `;
  }

  function getShopifySection(sectionEl) {
    if (!sectionEl) return null;
    const byId = sectionEl.dataset.sectionId
      ? document.getElementById(`shopify-section-${sectionEl.dataset.sectionId}`)
      : null;
    return byId || sectionEl.closest('.shopify-section');
  }

  function hideSection(sectionEl) {
    if (!sectionEl) return;
    sectionEl.classList.add('is-empty');
    const shopifySection = getShopifySection(sectionEl);
    if (shopifySection) {
      shopifySection.style.setProperty('display', 'none', 'important');
      shopifySection.setAttribute('hidden', '');
    }
  }

  function showSection(sectionEl) {
    if (!sectionEl) return;
    sectionEl.classList.remove('is-empty');
    const shopifySection = getShopifySection(sectionEl);
    if (shopifySection) {
      shopifySection.style.setProperty('display', 'block', 'important');
      shopifySection.removeAttribute('hidden');
    }
  }

  function renderSections() {
    const sections = document.querySelectorAll('[data-recently-viewed-section]');
    if (!sections.length) return;

    const list = readList();

    sections.forEach((sectionEl) => {
      const track = sectionEl.querySelector('[data-recently-viewed-track]');
      if (!track) return;

      // Theme editor: keep placeholders visible
      if (sectionEl.dataset.designMode === 'true') return;

      const limit = Number(sectionEl.dataset.productsToShow || 8);
      const priceNote = sectionEl.dataset.priceNote || '税込';
      const excludeHandle = sectionEl.dataset.excludeHandle || '';
      const items = list
        .filter((item) => item && item.handle && item.handle !== excludeHandle)
        .slice(0, limit);

      if (!items.length) {
        hideSection(sectionEl);
        return;
      }

      track.innerHTML = items
        .map((item) => `<div class="product-history-rail__item">${buildCard(item, priceNote)}</div>`)
        .join('');
      showSection(sectionEl);
    });
  }

  function init() {
    trackCurrentProduct();
    renderSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
